/**
 * File navigation.js.
 *
 * Handles toggling the navigation menu for small screens and enables TAB key
 * navigation support for dropdown menus.
 */

function mobileNavigation() {
  var menu = document.querySelector("#mobile-nav");
  var mMenu = document.querySelector("#mobile-menu");
  var menuButton = document.querySelector("#menu-toggle");

  if (menuButton) {
    menuButton.addEventListener("click", function() {
      if (!menu.classList.contains("mobile-menu-open")) {
        menu.classList.add("mobile-menu-open");
        menuButton.classList.add("toggled");
        document.querySelector("html").classList.add("no-scroll");
        menuButton.setAttribute("aria-expanded", "true");
      } else if (menu.classList.contains("mobile-menu-open")) {
        menu.classList.remove("mobile-menu-open");
        menuButton.classList.remove("toggled");
        document.querySelector("html").classList.remove("no-scroll");
        menuButton.setAttribute("aria-expanded", "false");
      }
    });
  }

  document.querySelectorAll(".mobile-menu-item").forEach((i) => {
    i.addEventListener("click", function() {
      menu.classList.remove("mobile-menu-open");
      menuButton.classList.remove("toggled");
      document.querySelector("html").classList.remove("no-scroll");
      menuButton.setAttribute("aria-expanded", "false");
    });
  });
  document.querySelectorAll(".cta-mobile , .logo").forEach((i) => {
    i.addEventListener("click", function() {
      if (menu.classList.contains("mobile-menu-open")) {
        menu.classList.remove("mobile-menu-open");
        menuButton.classList.remove("toggled");
        document.querySelector("html").classList.remove("no-scroll");
        menuButton.setAttribute("aria-expanded", "false");
      }
    });
  });
}

mobileNavigation();
